"use client";
import React, { useId } from "react";

export default function Input({
  state,
  setState,
  placeholder = "placeholder",
  title = "IP address or prefix:",
  validation = null,
  ...props
}) {
  const id = useId();

  const changeHandler = (e) => {
    const value = e.target.value;
    // Always update the state to allow typing
    setState(value);
  };

  return (
    <div className=" w-full">
      <span className=" text-sm lg:text-base inline-block font-normal leading-6 tracking-[0.5px] dark:text-dark-neutral-default text-neutral-default mb-3">
        {title}
      </span>
      <label
        className={`flex input lg:text-base text-sm items-center cursor-text bg-transparent relative w-full ${props?.disabled ? "opacity-50" : ""}`}
        htmlFor={id}
      >
        <input
          autoComplete="false"
          value={state}
          onChange={changeHandler}
          className={`bg-transparent p-[19px] focus:p-[18px] outline-none   w-full h-full border dark:border-dark-medium border-medium rounded focus:border-[2px] dark:placeholder:text-dark-placeholder placeholder:text-placeholder placeholder:font-light ${props?.disabled ? "cursor-not-allowed" : ""}`}
          id={id}
          type="text"
          placeholder={placeholder}
          {...props}
        />
      </label>
    </div>
  );
}
